import { selectPermissionScopeDetail } from '@bom-nextgen-keycloak/web/core';
import {
  FormBox,
  FormField,
  TextField,
} from '@bom-nextgen-keycloak/web/shared/ui';
import {
  MESSAGE_NO_BEGINNING_SPACE_REGEX,
  NO_BEGINNING_SPACE_REGEX,
} from '@bom-nextgen-keycloak/web/shared/util';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import * as yup from 'yup';

export const validationSchema = yup.object({
  displayName: yup
    .string()
    .matches(NO_BEGINNING_SPACE_REGEX, MESSAGE_NO_BEGINNING_SPACE_REGEX)
    .required('Display name is required'),
  name: yup
    .string()
    .matches(NO_BEGINNING_SPACE_REGEX, MESSAGE_NO_BEGINNING_SPACE_REGEX)
    .required('Name is required'),
});

type ScopeFormProps = {
  isEdit?: boolean;
};

const ScopeForm: FC<ScopeFormProps> = ({ isEdit }) => {
  const { isEditGeneralTab } = useSelector(selectPermissionScopeDetail);
  const disableButton = isEdit && !isEditGeneralTab;

  return (
    <FormBox>
      <FormField>
        <TextField
          autoFocus
          disabled={disableButton}
          label="Name"
          name="name"
          required
        />
      </FormField>
      <FormField>
        <TextField
          disabled={disableButton}
          label="Display name"
          name="displayName"
          required
        />
      </FormField>
    </FormBox>
  );
};

export { ScopeForm };
